import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import FormError from '../FormError';
import FormGroup from '../FormGroup';
import FormLabel from '../FormLabel';

const FormGroupSelect = ({
  input,
  label,
  type,
  options,
  placeholder,
  placeholderValue,
  placeholderSelectable,
  isArchived,
  meta: { touched, error, active },
  ...restProps
}) => (
  <FormGroup active={active} error={error} touched={touched}>
    {label && <FormLabel htmlFor={input.name}>{label}</FormLabel>}

    <select
      className={cn('form__select', {
        'is-archived': isArchived,
      })}
      data-test="select-field"
      id={input.name}
      {...input}
      {...restProps}
    >
      {placeholder && (
        <option disabled={!placeholderSelectable} value={placeholderValue}>
          {placeholder}
        </option>
      )}

      {options &&
        options.map(({ label, value }) => (
          <option key={label} value={value}>
            {label}
          </option>
        ))}
    </select>

    {touched && error && <FormError>{error}</FormError>}
  </FormGroup>
);

FormGroupSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  isArchived: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.shape({
    active: PropTypes.bool,
    error: PropTypes.string,
    touched: PropTypes.bool,
  }),
  placeholder: PropTypes.string,
  placeholderSelectable: PropTypes.bool,
  placeholderValue: PropTypes.string,
  type: PropTypes.string,
};

FormGroupSelect.defaultProps = {
  input: {
    name: '',
    value: '',
    defaultValue: '',
  },
  label: '',
  type: '',
  meta: {
    touched: false,
    error: '',
  },
  isArchived: false,
  placeholder: null,
  placeholderValue: '',
  placeholderSelectable: false,
};

export default FormGroupSelect;
